const menu = document.querySelector('.header__inline-menu');
const items = menu ? menu.querySelectorAll('details') : [];

const timerMap = new WeakMap();
const CLOSE_DELAY = 140; // 可调 100~180ms

function cancelClose(d){
  const t = timerMap.get(d);
  if (t) { clearTimeout(t); timerMap.delete(d); }
}

function openNow(d){
  cancelClose(d);
  // 立刻关闭兄弟项（避免切换时卡顿/重叠）
  items.forEach(sib => {
    if (sib !== d) {
      cancelClose(sib);
      sib.removeAttribute('open');
    }
  });
  d.setAttribute('open','');
}

function scheduleClose(d){
  cancelClose(d);
  const t = setTimeout(() => d.removeAttribute('open'), CLOSE_DELAY);
  timerMap.set(d, t);
}

items.forEach(item => {
  const summary = item.querySelector('summary');
  const submenu = item.querySelector('ul'); // 你的结构里是 ul 作为子菜单

  // 禁用父级点击的默认切换（避免点击收起）
  if (summary) summary.addEventListener('click', e => e.preventDefault());

  // —— 打开：进入父项或子菜单都立即打开
  item.addEventListener('pointerenter', () => openNow(item));
  if (submenu) submenu.addEventListener('pointerenter', () => openNow(item));

  // —— 关闭：离开整个 details 或离开子菜单时延时关闭
  item.addEventListener('pointerleave', () => scheduleClose(item));
  if (submenu) submenu.addEventListener('pointerleave', () => scheduleClose(item));
});

